import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWalletOpen = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m16.723 3.755-9.5 2.961a.75.75 0 1 1-.446-1.432l9.5-2.961c.217-.071.447-.091.674-.056.23.036.444.126.629.256s.336.297.451.484c.114.185.192.39.234.6l.469 2.24a.75.75 0 1 1-1.468.307l-.472-2.252a.3.3 0 0 0-.04-.109.2.2 0 0 0-.03-.038M2.89 8.85A2.17 2.17 0 0 1 4.39 8.25H17.61c.557 0 1.099.212 1.502.599.405.388.639.921.639 1.484v1.774h.536c.887 0 1.607.72 1.607 1.607v2.572c0 .887-.72 1.607-1.607 1.607h-.536v1.774c0 .563-.234 1.096-.639 1.484a2.17 2.17 0 0 1-1.502.599H4.39a2.17 2.17 0 0 1-1.502-.599 2.06 2.06 0 0 1-.639-1.484v-9.334c0-.563.234-1.096.639-1.484m15.361 9.044H16c-.888 0-1.607-.72-1.607-1.607v-2.572c0-.887.72-1.607 1.607-1.607h2.25v-1.774c0-.144-.06-.289-.176-.401a.67.67 0 0 0-.465-.182H4.39a.67.67 0 0 0-.465.182.56.56 0 0 0-.176.401v9.334c0 .144.06.289.176.401a.67.67 0 0 0 .465.182H17.61c.18 0 .346-.069.465-.182a.56.56 0 0 0 .176-.401zm-2.357-4.179c0-.059.048-.107.107-.107h4.286c.059 0 .107.048.107.107v2.572c0 .059-.048.107-.107.107H16a.107.107 0 0 1-.107-.107z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWalletOpen;
